export default {
  title: 'Acest restaurant nu poate fi lansat încă',
  description:
    'Contul tău de partener nu are un comision de procesare pentru plățile online și nu a confirmat o marjă de 0%. Stripe percepe comisioanele sale platformei tale, așa că trebuie decisă mai întâi una dintre cele două variante.',
  partner_action:
    'Stabilește un comision de procesare implicit sau confirmă că nu percepi niciunul restaurantelor tale și că plătești tu comisioanele Stripe.',
  ask_partner:
    'Partnerul dvs. nu și-a setat încă comisionul de procesare pentru plățile online. Acest restaurant poate fi lansat după ce acesta este setat.',
  buttons: {
    set_rate: 'Setează comisionul de procesare',
    close: 'Închide',
  },
};
